// extracted by mini-css-extract-plugin
export default {"wrapper":"radio_wrapper__OcR-M","disabled":"radio_disabled__Wbfcw"};